module.exports = __webpack_public_path__ + "img/thank_you_bg.b0f3b540.png";